import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import Header from 'components/layout/header/Header'
import Footer from 'components/layout/Footer'
import SvgSpriteSheet from 'components/util/SvgSpriteSheet'
import { selectUserId, selectUsername, selectLoggedIn, selectStoreLink } from 'services/user/selectors'
import { selectIsRefreshingToken } from 'services/auth/selectors'
import { selectDev } from 'services/site/selectors'
import * as notificationSelectors from 'services/notifications/selectors'
import { changeAdUnitPaths } from 'services/ads/actions'
import './_reset.global.css'
import './_fonts.global.css'
import './_global.global.css'
import styles from './_layout.css'
import ErrorNotification from './notifications/Error'
import RefreshingTokenModal from 'components/auth/RefreshingModal'
import classnames from 'classnames'
import Ad from 'components/util/ads/Ad'
import { AD_SIZES } from 'services/ads/constants'
import Interstitial from 'components/util/ads/Interstitial'

import fitnessFavicon from 'images/sites/fitness/favicon.ico'
import walkFavicon from 'images/sites/walk/favicon.ico'
import runFavicon from 'images/sites/run/favicon.ico'
import rideFavicon from 'images/sites/ride/favicon.ico'
import hikeFavicon from 'images/sites/hike/favicon.ico'

const favicons = {
  fitness: fitnessFavicon,
  walk: walkFavicon,
  run: runFavicon,
  ride: rideFavicon,
  hike: hikeFavicon,
}

import fitnessAppleIcon from 'images/sites/fitness/apple-touch-icon.png'
import walkAppleIcon from 'images/sites/walk/apple-touch-icon.png'
import runAppleIcon from 'images/sites/run/apple-touch-icon.png'
import rideAppleIcon from 'images/sites/ride/apple-touch-icon.png'
import hikeAppleIcon from 'images/sites/hike/apple-touch-icon.png'

const appleIcons = {
  fitness: fitnessAppleIcon,
  walk: walkAppleIcon,
  run: runAppleIcon,
  ride: rideAppleIcon,
  hike: hikeAppleIcon,
}

const mapStateToProps = (state) => ({
  site: state.site,
  isDev: selectDev(state),
  username: selectUsername(state),
  userId: selectUserId(state),
  loggedIn: selectLoggedIn(state),
  storeLink: selectStoreLink(state),
  globalError: notificationSelectors.selectGlobalApiFailure(state),
  isRefreshingToken: selectIsRefreshingToken(state),
})

const mapDispatchToActions = {
  changeAdUnitPaths,
}

class Layout extends Component {

  static propTypes = {
    className: PropTypes.string,
    showShortcuts: PropTypes.bool,
    showPremium: PropTypes.bool,
    showAuth: PropTypes.bool,
    showPrivacyHelp: PropTypes.bool,
    navContainer: PropTypes.bool,
    middleContainer: PropTypes.bool,
    children: PropTypes.node,
    site: PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
      shortName: PropTypes.string,
    }),
    username: PropTypes.string,
    loggedIn: PropTypes.bool,
    storeLink: PropTypes.string,
    userId: PropTypes.number,
    globalError: PropTypes.bool,
    routes: PropTypes.array,
    changeAdUnitPaths: PropTypes.func.isRequired,
    uacf: PropTypes.bool,
    showFooter: PropTypes.bool,
    showHeader: PropTypes.bool,
    isRefreshingToken: PropTypes.bool,
    isDev: PropTypes.bool,
  }

  static defaultProps = {
    showShortcuts: true,
    showPremium: true,
    showAuth: true,
    showPrivacyHelp: false,
    navContainer: true,
    middleContainer: true,
    showMainNav: true,
    showMobileNav: true,
    showHeader: true,
    showFooter: true,
    uacf: false,
    isRefreshingToken: false,
  }

  state = {
    showRefreshModal: false,
  }

  componentDidMount () {
    const adUnitPaths = this.props.routes.reduce(this.reduceAdUnitPaths, [])
    if (adUnitPaths.join('') !== '') {
      this.props.changeAdUnitPaths(adUnitPaths)
    }
  }

  componentWillReceiveProps (nextProps) {
    const adUnitPaths = this.props.routes.reduce(this.reduceAdUnitPaths, [])
    const nextAdUnitPaths = nextProps.routes.reduce(this.reduceAdUnitPaths, [])
    if (adUnitPaths.join('') !== nextAdUnitPaths.join('')) {
      this.props.changeAdUnitPaths(nextAdUnitPaths)
    }

    if (!this.props.isRefreshingToken && nextProps.isRefreshingToken) {
      this.setState({ showRefreshModal: true })
    } else if (this.props.isRefreshingToken && !nextProps.isRefreshingToken) {
      this.setState({ showRefreshModal: false })
    }
  }

  reduceAdUnitPaths (prev, curr) {
    return curr && curr.adUnitPaths ? curr.adUnitPaths : prev
  }

  render () {
    const {
      site,
      children,
      globalError,
      className: _className,
      middleContainer,
      uacf,
      showHeader,
      showFooter,
      isDev,
    } = this.props

    const className = classnames(styles.container, site.slug, _className, {
      uacf,
      [styles.middleContainer]: middleContainer,
    })

    const { showRefreshModal } = this.state
    const defaultTitle = isDev ? `(dev) ${site.name}` : site.name

    return (
      <div className={className}>
        <RefreshingTokenModal
          scrollable={true}
          isOpen={showRefreshModal}
        />

        <Helmet
          defaultTitle={defaultTitle}
          titleTemplate={`%s | ${site.name}`}
          link={
            [
              {
                rel: 'shortcut icon',
                href: favicons[site.slug],
              },
              {
                rel: 'apple-touch-icon',
                href: appleIcons[site.slug],
              },
            ]
          }
        />
        <div id='masthead' className={styles.top}>
          <Ad sizes={[AD_SIZES.BANNER_1]} />
          {showHeader ?
            <Header {...this.props} />
          : null }
        </div>
        <div className={styles.middle}>
          { children }
          <Ad position={'bottom'} sizes={[AD_SIZES.BANNER_1]} />
        </div>
        {showFooter ?
          <div className={styles.bottom}>
            <Footer {...this.props} />
          </div>
        : null}
        <SvgSpriteSheet />
        {globalError ? <ErrorNotification /> : null}
        <Interstitial />
      </div>
    )
  }

}

export default connect(mapStateToProps, mapDispatchToActions)(Layout)



// WEBPACK FOOTER //
// ./src/components/layout/Layout.jsx